import HelpModalLink from './HelpModalLink';

/**
 * The label row above a column selector, with the help modal link when
 * Contentstack has it positioned top right.
 */
export default function ColumnSelectorHeader({ label, helpModal }) {
  return (
    <div className="flex justify-between">
      <div className="sh12 text-crisp-white">{label}</div>
      <HelpModalLink helpModal={helpModal} position="Top Right" />
    </div>
  );
}
